import { Collapse, Divider, IconButton, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, TableRow, Tooltip, useTheme } from "@material-ui/core";
import { FC, useState } from "react";
import { ComponenteType, PedidosItensType } from "src/types";
import './styles.scss';
import { KeyboardArrowRight, KeyboardArrowLeft } from "@material-ui/icons";
import { faCaretDown, faCaretUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { CacheType } from "src/store/global.store";

export interface PagamentoListagemComponentesProperties {
    itens?: PedidosItensType[];
    hidenDescription?: boolean;
}

interface TablePaginationActionsProperties {
    count: number;
    page: number;
    rowsPerPage: number;
    onPageChange: (event: React.MouseEvent<HTMLButtonElement>, newPage: number) => void;
}

function TablePaginationActions(props: TablePaginationActionsProperties) {
    const theme = useTheme();
    const { count, page, rowsPerPage, onPageChange } = props;


    const handleFirstPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, 0);
    };

    const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page - 1);
    };

    const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, page + 1);
    };

    const handleLastPageButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
    };

    return (
        <div className="PagamentoListagemComponentesPaginador">
            <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
                {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
            </IconButton>
            <IconButton
                onClick={handleNextButtonClick}
                disabled={page >= Math.ceil(count / rowsPerPage) - 1}
                aria-label="next page"
            >
                {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </IconButton>
        </div>
    );
}

const PagamentoListagemComponentes: FC<PagamentoListagemComponentesProperties> = ({
    itens,
    hidenDescription = false
}) => {

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openList, setOpenList] = useState<boolean>(false);

    const _componentes = LocalStorage.get<CacheType<ComponenteType[]> | null>("solar.componentes", true)
    const _uploadInfo: any = LocalStorage.get<CacheType<any> | null>("solar.uploadInfo", true)

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    return <>
        <div className="PagamentoListagemComponentes">
            <div className="row">
                <div className="X12 Divisor">
                    <div className="title" onClick={() => setOpenList(!openList)}>Itens {`(${itens?.length ? itens.length : 0})`}<FontAwesomeIcon icon={openList ? faCaretUp : faCaretDown} className={"icon"} /></div>
                    <Divider />
                </div>
            </div>
            <Collapse in={openList}>
                <div className="row">
                    <div className="X12">
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Equipamentos</TableCell>
                                        <TableCell align="right">Quantidade</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(rowsPerPage > 0
                                        ? itens?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                        : itens)?.map((row, index) => {
                                            const componenteCache = _componentes?.data?.find((c: ComponenteType) => row.componente_id === c.id)
                                            return (
                                                <TableRow key={`itens-componentes-${row.id}-${index}`}>
                                                    <TableCell>
                                                        <div className="item">
                                                            <div className="icon">
                                                                {componenteCache && componenteCache?.imagem && <img width={"64px"} src={`//${_uploadInfo?.data?.url || ""}${componenteCache?.imagem || ""}`} />}
                                                            </div>
                                                            <div className="content">
                                                                <Tooltip title={componenteCache?.descricao ? componenteCache.descricao : ""}>
                                                                    <div className="nome">{componenteCache?.nome}</div>
                                                                </Tooltip>
                                                                {!hidenDescription &&<div className="descricao">{componenteCache?.descricao}</div>}
                                                            </div>

                                                        </div>
                                                    </TableCell>
                                                    <TableCell  size="small" align="right">{row.quantidade} {row.unidade_medida}</TableCell>
                                                </TableRow>
                                            )
                                        })}
                                </TableBody>
                                <TableFooter>
                                    <TableRow>
                                        <TablePagination
                                            rowsPerPageOptions={[5, 10, 25, { label: 'Todos', value: -1 }]}
                                            colSpan={3}
                                            count={itens ? itens.length : 0}
                                            rowsPerPage={rowsPerPage}
                                            page={page}
                                            SelectProps={{
                                                inputProps: { 'aria-label': 'rows per page' },
                                                native: false,
                                            }}
                                            onPageChange={handleChangePage}
                                            onRowsPerPageChange={handleChangeRowsPerPage}
                                            ActionsComponent={TablePaginationActions}
                                        />
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>
                    </div>
                </div>
            </Collapse>

        </div>
    </>
}

export { PagamentoListagemComponentes }